<script>
import FormLayout from "../../router/layouts/form";
import Multiselect from "vue-multiselect";
import api from "../../services/api";

/**
 * Nav-bar Component
 */
export default {
  components: {
    FormLayout,
    Multiselect,
  },
  props: {
    resource: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      logoContent: '',
      listRoles: [],
      send_reset_link: false
    };
  },
  created() {
    this.loadDependencies();
  },
  methods: {
    async loadDependencies() {
      await api.get('roles').then((result) => {
        this.listRoles = result.data.data;
      })
    },
    changeLogo(event) {
      const fileObject = event.target.files[0];

      if (!fileObject) {
        this.logoContent = "";
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        this.resource.picture = {
          name: fileObject.name,
          content: btoa(e.target.result)
        };
        this.logoContent = "data:image;base64, " + this.resource.picture.content;
      };

      reader.onerror = function (error) {
        alert(error);
      };

      reader.readAsBinaryString(fileObject);
    },
    submitted() {
      if (this.send_reset_link) {
        api.post('forgot-password', {email: this.resource.email});
      }
      this.$emit('submitted');
    }
  }
}
;
</script>

<template>
  <b-card no-body class="mb-0">
    <form-layout
        @submitted="submitted"
        @cancel="$emit('cancel')"
        :resource="resource"
        resource-name="user"
    >
      <b-row>
        <b-col>
          <div class="form-check form-switch mb-3 float-end">
            <input
                class="form-check-input"
                type="checkbox"
                id="form-enable"
                v-model="resource.enable"
            />
            <label class="form-check-label" for="form-enable"
            >{{ $t('general.enable') }}</label
            >
          </div>
        </b-col>
      </b-row>
      <b-row no-gutters class="justify-content-md-center">
        <b-col md="4">
          <b-form-group :label="$t('general.logo')" class="mb-3" label-for="formrow-logo-input">
            <div v-if="logoContent" class="text-center">
              <b-card-img :src="logoContent" class="img-fluid w-auto mb-1"
                          style="max-height: 100px"></b-card-img>
            </div>
            <input class="form-control" type="file" id="formrow-logo-input" accept="image/png, image/jpeg"
                   @change="changeLogo"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row no-gutters class="align-items-center">
        <b-col>
          <b-form-group :label="$t('general.first-name')" class="mb-3" label-for="formrow-first_name-input">
            <b-form-input id="formrow-first_name-input" type="text" v-model="resource.first_name"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('general.last-name')" class="mb-3" label-for="formrow-last_name-input">
            <b-form-input id="formrow-last_name-input" type="text" v-model="resource.last_name"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row no-gutters class="align-items-center">
        <b-col>
          <b-form-group :label="$t('general.email')" class="mb-3" label-for="formrow-email-input">
            <b-form-input id="formrow-email-input" type="text"
                          v-model="resource.email"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row no-gutters class="align-items-center">
        <b-col>
          <b-form-group :label="$t('general.address')" class="mb-3" label-for="formrow-address-input">
            <b-form-input id="formrow-address-input" type="text"
                          v-model="resource.address"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row no-gutters class="align-items-center">
        <b-col>
          <b-form-group :label="$t('general.additional-address')" class="mb-3"
                        label-for="formrow-additional_address-input">
            <b-form-input id="formrow-additional_address-input" type="text"
                          v-model="resource.additionnal_address"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row no-gutters class="align-items-center">
        <b-col>
          <b-form-group :label="$t('general.zip-code')" class="mb-3" label-for="formrow-zip_code-input">
            <b-form-input id="formrow-zip_code-input" type="text"
                          v-model="resource.zip_code"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('general.city')" class="mb-3" label-for="formrow-city-input">
            <b-form-input id="formrow-city-input" type="text"
                          v-model="resource.city"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>


      <b-row no-gutters class="align-items-center">
        <b-col>
          <b-form-group :label="$t('general.roles')" class="mb-3" label-for="formrow-roles">
            <multiselect
                id="formrow-roles"
                v-model="resource.roles"
                :options="listRoles"
                label="name"
                track-by="id"
                :show-labels="false"
                :multiple="true"
            >
              <template slot="tag" slot-scope="props">
                    <span class="badge badge-soft-primary me-2"
                          role="button"
                          @click="props.remove(props.option)"
                    >
                      {{ $t(`general.${props.option.name}`) }}
                    </span>
              </template>
              <template slot="option" slot-scope="props">
                <div class="option__desc"><span class="option__title">{{ $t(`general.${props.option.name}`) }}</span><span class="option__small">{{ props.option.desc }}</span></div>
              </template>
            </multiselect>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col v-if="resource.enable">
          <div class="form-check form-switch mb-3 float-end">
            <input
                class="form-check-input"
                type="checkbox"
                id="form-send_reset_mail"
                v-model="send_reset_link"
            />
            <label class="form-check-label" for="form-send_reset_mail"
            >{{ $t('general.send-reset-mail') }}</label
            >
          </div>
        </b-col>
      </b-row>
    </form-layout>
  </b-card>
</template>